import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const VietnamFlag = ({ size = 40, ...props }: Props) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    style={{ borderRadius: "50%" }}
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_vietnam)">
      <rect width="512" height="512" fill="#da251d" />
      <path
        d="M256 156L278 225L351 225L292 268L315 337L256 294L197 337L220 268L161 225L234 225Z"
        fill="#ffff00"
      />
    </g>
    <defs>
      <clipPath id="clip0_vietnam">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
